import ChallengeResultInfo from './ChallengeResultInfo';

export default ChallengeResultInfo;
